import { useMemo } from 'react'

import QuizQuestionsSelector from '@v4/utils/selectors/QuizQuestionsSelector'
import QuestionsBuilderSelector from '@v4/utils/selectors/QuestionsBuilderSelector'
import useQuestionField from '@v4/hooks/questions/useQuestionField'

const useQuestionCategories = () => {
	const categoryEntities = QuizQuestionsSelector.useCategoryEntities()
	const activeQuestionId = QuestionsBuilderSelector.useActiveQuestionId()
	const questionCategories = useQuestionField(activeQuestionId, 'categories')
	const questionOptions = useQuestionField(activeQuestionId, 'options')

	const categories = useMemo(() => {
		if (!_.isEmpty(questionCategories)) {
			const array = _.map(
				questionCategories,
				category => categoryEntities[category.category_id || category.category_temporary_id],
			)
			return _.filter(array, Boolean)
		}

		const items = []

		_.each(questionOptions, option => {
			_.each(option.categories || option.scores, category => {
				if (category.category_id === null || category.category_id === 'none') {
					return
				}
				items.push(categoryEntities[category.category_id || category.category_temporary_id])
			})
		})

		return _.uniq(items)
	}, [categoryEntities, questionCategories, questionOptions])

	return categories
}

export default useQuestionCategories
